module.exports = __webpack_public_path__ + "img/Weapon_120.7f414cba.png";